import React from 'react';
import ReactDOM from 'react-dom';
import '../../../../sass/base.scss';
import '../../../../sass/components/header/base_header.scss';
import '../../../../sass/components/utils.scss';
import '../../../../sass/pages/listing/mobile/detail.scss';
import '../../../../sass/pages/listing/co_living_amenities.scss';
import '../../../../sass/pages/listing/report_ad.scss';
import '../../../../sass/components/safety_tip.scss';
import '../../../../sass/components/verified_box.scss';
import triggerRegistrationPromptMobileDetail from '../../../components/list/registration_prompt_mobile_with_exp_ads_details';
import renderReportAdModal from '../report_ad_modal';
import get from '../../../helpers/data_layer/get';
import ShareFallback from './share_fallback';
import copyTextToClipboard from '../../../helpers/copyTextToClipboard';
import FloatingMessageBox from '../../../components/FloatingMessageBox';
import to_upper_case_first from '../../../helpers/to_upper_case_first';
import bindFacebookLoginButtons from '../components/facebookLogin';
import storeLastViewedListing from '../components/storeLastViewedListing';
import toggleAmenitiesList from './amenities_list_toggle';
import {
  track_copy_link,
  track_share_button,
  track_native_share,
  track_hide_ad_button,
  track_save_ad_button,
} from './tracking';
import { fetchData } from '../../../helpers/base_data_fetcher';

if (typeof module !== 'undefined') {
  if (module && module.hot) {
    module.hot.accept();
  }
}

renderReportAdModal();
bindFacebookLoginButtons();
toggleAmenitiesList();

const advert_data = get('page.advert');
const listingType = advert_data.type;

const toggleButton = document.getElementById('buttonReadMore');
const descriptionBody = document.querySelector('.feature__description-body');

if (toggleButton) {
  fetchData('page.localisations').then((localisations) => {
    toggleButton.addEventListener('click', () => {
      descriptionBody.classList.toggle('feature__description-body--full');
      const currentText = toggleButton.innerText;
      toggleButton.innerText =
        currentText == localisations.read_more
          ? localisations.done
          : localisations.read_more;
    });
  });
}

triggerRegistrationPromptMobileDetail();

function addTrackingToBackLink(event) {
  if (!window.dataLayer) {
    return false;
  }
  const adType = flatshareType == 'wanted' ? 'flatmate' : 'flatshare';
  return window.dataLayer.push({
    event: 'ga.event',
    ga_event_category: 'nav',
    ga_event_action: `${adType}_details_back`,
    ga_event_label: '',
  });
}

const backLink = document.querySelector('nav.main .lhs');
if (backLink) {
  backLink.addEventListener('click', addTrackingToBackLink);
}

// copy and share

const canonicalLink = document.querySelector('link[rel="canonical"]');
const canonicalUrl = canonicalLink.href;
const copyButtons = document.querySelectorAll('[data-copy-button]');
const shareButtons = document.querySelectorAll('[data-share-button]');

function copyUrlToClipboard() {
  const { trackingLocation } = this.dataset;
  track_copy_link({ location: trackingLocation });
  copyTextToClipboard({
    text: canonicalUrl,
    successCallback: copySuccessFeedback,
  });
}

async function openNativeShareOptions() {
  const { trackingLocation } = this.dataset;
  track_share_button({ location: trackingLocation });
  navigator
    .share({
      text: to_upper_case_first(advert_data.share_title),
      url: canonicalUrl,
    })
    .then(() => track_native_share({ success: true }))
    .catch((error) => track_native_share({ success: false }));
}
if (copyButtons.length) {
  copyButtons.forEach((button) =>
    button.addEventListener('click', copyUrlToClipboard),
  );
}

if (shareButtons.length) {
  if (navigator.share) {
    shareButtons.forEach((button) =>
      button.addEventListener('click', openNativeShareOptions),
    );
  } else if (!navigator.share) {
    fetchData('page.localisations').then((localisations) => {
      // should be able to code split this
      let fallbackMountElement = document.querySelector('#share-fallback-app');
      if (!fallbackMountElement) {
        fallbackMountElement = document.createElement('div');
        fallbackMountElement.id = 'share-fallback-app';
        document.body.appendChild(fallbackMountElement);
      }
      ReactDOM.render(
        <ShareFallback
          shareUrl={canonicalUrl}
          shareTitle={to_upper_case_first(advert_data.share_title)}
          flatshareType={listingType}
          advertId={advert_data.id}
          modalLabelText={localisations.share_ad}
          copyLinkText={localisations.copy_link}
          emailText={localisations.email}
        />,
        fallbackMountElement,
      );
    });
  }
}

function copySuccessFeedback() {
  let successMountElement = document.querySelector('#copy-success-app');

  function closeMessageBox() {
    ReactDOM.unmountComponentAtNode(successMountElement);
  }

  fetchData('page.localisations.copied_to_clipboard').then((message) => {
    if (!successMountElement) {
      successMountElement = document.createElement('div');
      successMountElement.id = 'copy-success-app';
      document.body.appendChild(successMountElement);
    }
    ReactDOM.render(
      <FloatingMessageBox ariaLive="assertive" onClose={closeMessageBox}>
        {message}
      </FloatingMessageBox>,
      successMountElement,
    );
  });
}

const stickyContactButtons = document.querySelector('.contact_methods--sticky');
const hurryElement = document.querySelector('.block_area.hurry');
// need to feature check this?
try {
  const observer = new IntersectionObserver(([hurryBlock]) => {
    stickyContactButtons.classList.toggle(
      'contact_methods--stuck',
      hurryBlock.intersectionRatio == 0,
    );
  });

  observer.observe(hurryElement);
} catch (error) {
  console.log('IntersectionObserver not supported');
}

const hideLink = document.querySelector('[data-hide-link]');
const unHideLink = document.querySelector('[data-hidden-link]');
const saveAdLink = document.querySelector('[data-save-link]');
const savedAdLink = document.querySelector('[data-saved-link]');

if (hideLink) {
  hideLink.addEventListener('click', () =>
    track_hide_ad_button({ hide_action: 'hide' }),
  );
}
if (unHideLink) {
  unHideLink.addEventListener('click', () =>
    track_hide_ad_button({ hide_action: 'unhide' }),
  );
}
if (saveAdLink) {
  saveAdLink.addEventListener('click', () =>
    track_save_ad_button({ save_action: 'save' }),
  );
}
if (savedAdLink) {
  savedAdLink.addEventListener('click', () =>
    track_save_ad_button({ save_action: 'remove' }),
  );
}

storeLastViewedListing(listingType);
